import type {IModalOverlayVariant} from "@pg-design/modal-module";
import {UserPhoneVerification as UserPhoneVerificationBase} from "@pg-mono/user";

import {UserPhoneVerificationProvider} from "../../providers/UserPhoneVerificationProvider";
import {
    PhoneVerificationPlacementSource,
    trackAmplitudePhoneVerified,
    usePhoneVerificationAmplitudeContext,
    useTrackAmplitudePhoneVerifyModalView
} from "../../tracking/track_amplitude_phone_verified";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    onChangeNumber: () => void;
    overlayVariant?: IModalOverlayVariant;
    amplitudePlacementSource: PhoneVerificationPlacementSource;
}

export const HomeMatchBasicPreferencesFlowPhoneVerificationModal = (props: IProps) => {
    const {isOpen, onClose, onSuccess, onChangeNumber, overlayVariant, amplitudePlacementSource} = props;
    const amplitudeContext = usePhoneVerificationAmplitudeContext(amplitudePlacementSource);

    useTrackAmplitudePhoneVerifyModalView(amplitudeContext);

    const handleClose = () => {
        trackAmplitudePhoneVerified(false, amplitudeContext);
        onClose();
    };

    return (
        <UserPhoneVerificationProvider amplitudeContext={amplitudeContext}>
            <UserPhoneVerificationBase
                isOpen={isOpen}
                onClose={handleClose}
                onSuccess={onSuccess}
                onChangeNumber={onChangeNumber}
                overlayVariant={overlayVariant}
            />
        </UserPhoneVerificationProvider>
    );
};
import type {IModalOverlayVariant} from "@pg-design/modal-module";
import {UserPhoneVerification as UserPhoneVerificationBase} from "@pg-mono/user";

import {UserPhoneVerificationProvider} from "../../providers/UserPhoneVerificationProvider";
import {
    PhoneVerificationPlacementSource,
    trackAmplitudePhoneVerified,
    usePhoneVerificationAmplitudeContext,
    useTrackAmplitudePhoneVerifyModalView
} from "../../tracking/track_amplitude_phone_verified";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    onChangeNumber: () => void;
    overlayVariant?: IModalOverlayVariant;
    amplitudePlacementSource: PhoneVerificationPlacementSource;
}

export const HomeMatchBasicPreferencesFlowPhoneVerificationModal = (props: IProps) => {
    const {isOpen, onClose, onSuccess, onChangeNumber, overlayVariant, amplitudePlacementSource} = props;
    const amplitudeContext = usePhoneVerificationAmplitudeContext(amplitudePlacementSource);

    useTrackAmplitudePhoneVerifyModalView(amplitudeContext);

    const handleClose = () => {
        trackAmplitudePhoneVerified(false, amplitudeContext);
        onClose();
    };

    return (
        <UserPhoneVerificationProvider amplitudeContext={amplitudeContext}>
            <UserPhoneVerificationBase
                isOpen={isOpen}
                onClose={handleClose}
                onSuccess={onSuccess}
                onChangeNumber={onChangeNumber}
                overlayVariant={overlayVariant}
            />
        </UserPhoneVerificationProvider>
    );
};
